import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {physicianGuard} from '@app/auth/guards/physician.guard';
import {PatientSummaryComponent} from '@modules/cy/patient/ps/pages/patient-summary/patient-summary.component';
import {CreateEditRoutes} from '@modules/cy/patient/ps/create-edit/create-edit-routing.module';
import {pharmacistGuard} from '@app/auth/guards/pharmacist.guard';
import {PatientComponent} from '@modules/eu/country/patient/pages/patient/patient.component';
import {EpComponent} from '@modules/eu/country/patient/ep/pages/ep/ep.component';
import {OrcdComponent} from '@modules/eu/country/patient/orcd/pages/orcd/orcd.component';
import {PatientMenuComponent} from '@modules/eu/country/patient/ps/pages/patient-menu/patient-menu.component';
import {PsComponent} from '@modules/eu/country/patient/ps/pages/ps/ps.component';
import {physicianPharmacistGuard} from '@app/auth/guards/physician-pharmacist.guard';

export const PSRoutes: Routes = [
  {
    path: '',
    component: PatientMenuComponent,
    canActivate: [physicianPharmacistGuard],
  },
  {
    path: 'ps',
    component: PsComponent,
    canActivate: [physicianGuard],
  },
  {
    path: 'ep',
    component: EpComponent,
    canActivate: [pharmacistGuard],
  },
  {
    path: 'orcd',
    component: OrcdComponent,
    canActivate: [physicianGuard],
  },
  {
    path: '**',
    redirectTo: '/eu',
  },
];

@NgModule({
  imports: [RouterModule.forChild(PSRoutes)],
  exports: [RouterModule]
})
export class PsRoutingModule { }
